import React from 'react';
import { IonText } from '@ionic/react';

export const FlightChecklistError: React.FC = () => (
    <div style={{position: 'absolute', width: '85%', left: '50%', transform: 'translateX(-50%)', top: 50, borderRadius: 10, border: '1px solid lightgray', backgroundColor: 'var(--ion-color-light)', padding: '8px 16px', zIndex: 1}}>
        <IonText color="medium">Sorry, we were unable to evaluate the airspace. Try adjusting your location or radius slightly.</IonText>
    </div>
);
